const Contacts = {
  init() {
    Contacts.renderMap();
  },

  async renderMap() {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    let isMobile = window.innerWidth < 700;
    let adjustedZoom = isMobile ? 6.3 : 7.5;

    const initialPos = { lat: 56.95018, lng: 24.114629 };

    const mapEl = $("#map");
    const map = new window.google.maps.Map(mapEl[0], {
      center: initialPos,
      disableDefaultUI: true,
      zoom: adjustedZoom,
      mapId: "9f3e3363bf5d720b",
    });

    const markers = {};
    let markersCreated = false;

    var infowindow = new window.google.maps.InfoWindow();

    infowindow.addListener("closeclick", function () {
      map.setZoom(adjustedZoom);
      map.panTo(initialPos);
    });

    let events = [];
    if (document.getElementById("events")) {
      events = JSON.parse(document.getElementById("events").innerHTML);
    }

    const offices = JSON.parse(document.getElementById("mapData").innerHTML);

    const intersectionObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add("drop");
          intersectionObserver.unobserve(entry.target);
        }
      }
    });

    map.addListener("mapcapabilities_changed", () => {
      const mapCapabilities = map.getMapCapabilities();

      // checking if AdvancedMarkerView is available
      if (mapCapabilities.isAdvancedMarkersAvailable && !markersCreated) {
        events.forEach((item) => {
          const event = document.createElement("div");

          event.className = "event-tag";
          const icon = document.createElement("img");
          icon.src = mapIcons.event;
          event.appendChild(icon);

          const marker = new AdvancedMarkerElement({
            map,
            position: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) },
            content: event,
          });

          markers[item.id] = marker;

          window.google.maps.event.addListener(
            marker,
            "click",
            (function (marker) {
              return function () {
                infowindow.setContent(
                  Contacts.renderInfoWindow(
                    item.name,
                    item.date,
                    item.address,
                    item.description,
                  )
                );
                infowindow.open(map, marker);
                infowindow.setZIndex(9999999999);
                infowindow.setPosition({
                  lat: parseFloat(item.lat),
                  lng: parseFloat(item.lng),
                });
                map.setCenter({
                  lat: parseFloat(item.lat),
                  lng: parseFloat(item.lng),
                });
                // map.setZoom( map.getZoom() + 2 )
              };
            })(marker)
          );
        });

        offices.forEach((item) => {
          const office = document.createElement("div");

          office.className = "office-tag";
          item.type.forEach((officeType) => {
            const icon = document.createElement("img");
            switch (officeType) {
              case "dealer_center":
                icon.src = mapIcons.dealer_center;
                break;
              case "warehouse":
                icon.src = mapIcons.warehouse;
                break;
              case "delivery_point":
                icon.src = mapIcons.delivery_point;
                break;
              case "mechanic_base":
                icon.src = mapIcons.mechanic_base;
                break;
              case "partners":
                icon.src = mapIcons.partners;
                break;
            }
            office.appendChild(icon);
          });

          const marker = new window.google.maps.marker.AdvancedMarkerView({
            map,
            position: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) },
            content: office,
          });

          const styleEl = marker.content;

          styleEl.style.opacity = "0";
          styleEl.addEventListener("animationend", (event) => {
            styleEl.classList.remove("drop");
            styleEl.style.opacity = "1";
          });

          const time = 1 + Math.random(); // 2s delay for easy to see the animation

          styleEl.style.setProperty("--delay-time", time + "s");
          intersectionObserver.observe(styleEl);

          window.google.maps.event.addListener(
            marker,
            "click",
            (function (marker) {
              return function () {
                infowindow.setContent(Contacts.renderOfficeWindow(item));
                infowindow.open(map, marker);
                infowindow.setZIndex(9999999999);
                infowindow.setPosition({
                  lat: parseFloat(item.lat),
                  lng: parseFloat(item.lng),
                });
                map.setCenter({
                  lat: parseFloat(item.lat),
                  lng: parseFloat(item.lng),
                });
                // map.setZoom( map.getZoom() + 2 )
              };
            })(marker)
          );

          styleEl.addEventListener("mouseover", function () {
            styleEl.classList.toggle("active");
          });

          styleEl.addEventListener("mouseout", function () {
            styleEl.classList.toggle("active");
          });
        });

        markersCreated = true;
      }
    });

    const showEvent = $(".show-event");

    $(showEvent).on("click", function (e) {
      e.preventDefault();
      const eventID = $(this).attr("data-id");
      window.google.maps.event.trigger(markers[eventID], "click");
      $("html, body").animate(
        {
          scrollTop: $("#map").offset().top - 200,
        },
        1000
      );
    });
  },

  renderInfoWindow(title, date, address, description) {
    const contentString = `
        <div id="content">
          <div class="info-window-inner">
            <h3>${title}</h3>
            <div class="event-info">
              <div class="event-info__item">${date}</div>
              <div class="event-info__item">${address}</div>
            </div>
            <p class="event-description">${description}</p>
          </div>
        </div>`;
    return contentString;
  },

  renderOfficeWindow(item) {
    function decode(text) {
      var map = {
        "&amp;": "&",
        "&#038;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#039;": "'",
        "&#8217;": "’",
        "&#8216;": "‘",
        "&#8211;": "–",
        "&#8212;": "—",
        "&#8230;": "…",
        "&#8221;": "”",
      };

      return text.replace(/\&[\w\d\#]{2,5}\;/g, function (m) {
        return map[m];
      });
    }

    let contentString = `<div class="info-office info-window-inner">
      <p class="info-office__title">${item.title}</p>`;

    if (item.address) {
      contentString += `<div class="info-office__icon">
        <img src="${mapIcons.address}" />
        <p>${item.address}</p>
      </div>`;
    }
    if (item.phone) {
      item.phone.forEach((phone) => {
        // Split the phone numbers by comma
        const phoneNumbers = phone.phone_number.split(',');

        // Start the content string with the common HTML structure
        let phoneLinks = '';
        phoneNumbers.forEach((number, index) => {
          number = number.trim(); // Trim whitespace
          phoneLinks += `<a href="tel:${number}">${number}</a>${index < phoneNumbers.length - 1 ? ', ' : ''}`;
        });

        // Build description span only if phone_desc is not undefined and not empty
        const descriptionSpan = phone.phone_desc ? `<span>${phone.phone_desc}</span><br> ` : '';

        // Concatenate the contentString with the modified part including all phone links and the conditional description
        contentString += `<div class="info-office__icon">
             <img src="${mapIcons.phone}" />
             <p>${descriptionSpan}${phoneLinks}</p>
           </div>`;
      });
    }
    if (item.email) {
      contentString += `<div class="info-office__icon">
        <img src="${mapIcons.email}" />
        <p><a href="mailto:${item.email}">${item.email}</a></p>
      </div>`;
    }
    if (item.work_hours) {
      contentString += `<div class="info-office__icon">
        <img src="${mapIcons.worktime}" />
        <p>${item.work_hours}</p>
      </div>`;
    }

    contentString += `<div class="info-office__desc">
          ${decode(item.description)}
        </div>
      </div>`;

    return contentString;
  },
};

export default Contacts;
